import React, { useState } from "react";

import Button from "@mui/material/Button";

import { Column, Row } from "@rui/Stack";

import AdvancedSettingsModal from "./AdvancedSettingsModal";
import EditableSettings from "./EditableSettings";
import { PREVIEW_SETTINGS } from "./settings";

const CalendarStepSettings = () => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <Column
        spacing={4}
        borderTop="1px solid"
        borderColor="shades.neutral.100"
        width="100%"
        paddingTop={{ xxs: 3, md: 5 }}
      >
        <Column>
          <EditableSettings settings={PREVIEW_SETTINGS} isPreview />
        </Column>
        <Row variant="center">
          <Button variant="text" onClick={() => setModalOpen(true)}>
            Advanced Settings
          </Button>
        </Row>
      </Column>

      <AdvancedSettingsModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </>
  );
};

export default CalendarStepSettings;
